"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Logo = _interopRequireDefault(require("../../elements/Logo/Logo"));
var _templateObject;
var HamburgerNavStyles = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n\n  span {\n    flex: 1 0 0;\n  }\n\n  button {\n    border: none;\n    background: none;\n    font-weight: 800;\n    font-size: 32px;\n    width: 100px;\n    color: var(--bf-core-pink);\n  }\n"])));
var HamburgerNav = function HamburgerNav(_ref) {
  var handleMenu = _ref.handleMenu;
  return _react.default.createElement(HamburgerNavStyles, null, _react.default.createElement(_Logo.default, {
    large: true
  }), _react.default.createElement("span", null), _react.default.createElement("button", {
    onClick: handleMenu
  }, "\u2261"));
};
var _default = HamburgerNav;
exports.default = _default;